document.addEventListener("DOMContentLoaded", searchTabsInit, false);
document.addEventListener("shopify:section:load", searchTabsInit, false);
document.addEventListener("DOMContentLoaded", speechInit, false);
document.addEventListener("shopify:section:load", speechInit, false);
var $resultsBox = $('.yv-search-result-container');
var searchbarresult=$('body').find('.yv-header-searchbar-content');
var UPV_SEARCH_REQUEST_TIMEOUT = 10000;

function createSearchRequestState() {
    return {
        timer: null,
        deadlineTimer: null,
        controller: null,
        sequence: 0,
        open: false
    };
}

var predictiveSearchStates = {
    drawer: createSearchRequestState(),
    header: createSearchRequestState()
};
var recentSearchRequestState = createSearchRequestState();
var recentSearchViewState = {
    visible: false,
    loaded: false,
    html: '',
    noRecent: false
};

function getSearchSurface(inputField) {
    return inputField && inputField.hasClass('yv-search-bar') ? 'header' : 'drawer';
}

function getSearchDrawerClass() {
    var drawerTrigger = $('[data-search-drawer]').first();
    if (drawerTrigger.length && drawerTrigger.data('search-drawer')) {
        return drawerTrigger.data('search-drawer');
    }
    return 'addsearch';
}

function getSearchResultBox(surface) {
    if (surface == 'header') {
        return $('body').find('.yv-header-searchbar-content');
    }
    return $('body').find('.yv-search-result-container');
}

function getSearchInput(surface, inputElement) {
    if (inputElement) {
        return $(inputElement);
    }
    if (surface == 'header') {
        return $('.search-input.yv-search-bar');
    }
    return $('.search-input').not('.yv-search-bar');
}

function setSearchBusy(surface, busy, inputElement) {
    var busyValue = busy ? 'true' : 'false';
    getSearchInput(surface, inputElement).attr('aria-busy', busyValue);
    getSearchResultBox(surface).attr('aria-busy', busyValue);
    if (surface == 'drawer') {
        $('.search-drawer-result-count').attr('aria-busy', busyValue);
    }
}

function renderRecentSearchView() {
    var recentList = $('#recent_search_list');
    var resultBox = $('.recent-search-list').siblings('.yv-search-result-container');
    if (!recentSearchViewState.visible) {
        // Never leave hidden recent links in the drawer focus-trap DOM.
        recentList.html('');
        resultBox.removeClass('no-recent');
        return;
    }
    recentList.html(recentSearchViewState.html);
    if (recentSearchViewState.noRecent) {
        resultBox.addClass('no-recent');
    } else {
        resultBox.removeClass('no-recent');
    }
}

function resetRecentSearchView(visible) {
    recentSearchViewState.visible = visible === true;
    recentSearchViewState.loaded = false;
    recentSearchViewState.html = '';
    recentSearchViewState.noRecent = false;
    renderRecentSearchView();
}

function setRecentSearchViewVisible(visible) {
    var nextVisible = visible === true;
    if (recentSearchViewState.visible == nextVisible) {
        return;
    }
    recentSearchViewState.visible = nextVisible;
    renderRecentSearchView();
}

function updateRecentSearchView(html, noRecent) {
    recentSearchViewState.loaded = true;
    recentSearchViewState.html = String(html || '');
    recentSearchViewState.noRecent = noRecent === true;
    renderRecentSearchView();
}

function abortSearchController(controller) {
    if (!controller) {
        return;
    }
    try {
        if (typeof controller.abort == 'function') {
            controller.abort();
        }
    } catch (error) {}
}

function clearSearchRequestResources(state) {
    if (state.timer) {
        clearTimeout(state.timer);
        state.timer = null;
    }
    if (state.deadlineTimer) {
        clearTimeout(state.deadlineTimer);
        state.deadlineTimer = null;
    }
    if (state.controller) {
        var controller = state.controller;
        state.controller = null;
        abortSearchController(controller);
    }
}

function beginPredictiveSearchIntent(surface, inputElement) {
    var state = predictiveSearchStates[surface];
    state.sequence += 1;
    clearSearchRequestResources(state);
    state.open = true;
    // Retire the previous loader/result as soon as a newer intent exists. This
    // keeps the visual state aligned with aria-busy during the debounce window.
    clearPredictiveSearchSurface(surface);
    if (
        surface == 'drawer' &&
        isSearchSurfaceOpen('drawer') &&
        typeof focusElementsRotation == 'function'
    ) {
        // The old result links were just detached; rebuild the trap before the
        // debounce can leave it pointing at disconnected elements.
        focusElementsRotation($('.search-bar-container'));
    }
    setSearchBusy(surface, false, inputElement);
    return state.sequence;
}

function cancelPredictiveSearch(surface) {
    var state = predictiveSearchStates[surface];
    if (!state) {
        return;
    }
    state.sequence += 1;
    state.open = false;
    clearSearchRequestResources(state);
    setSearchBusy(surface, false);
}

function cancelRecentSearchRequest() {
    recentSearchRequestState.sequence += 1;
    recentSearchRequestState.open = false;
    clearSearchRequestResources(recentSearchRequestState);
}

function cancelAllSearchRequests() {
    cancelPredictiveSearch('drawer');
    cancelPredictiveSearch('header');
    cancelRecentSearchRequest();
}

function isSearchSurfaceOpen(surface) {
    if (surface == 'drawer') {
        return $('body').hasClass(getSearchDrawerClass());
    }
    return predictiveSearchStates.header.open;
}

function isCurrentPredictiveSearch(surface, sequence, inputElement, term, controller) {
    var state = predictiveSearchStates[surface];
    if (!state || state.sequence != sequence || !state.open) {
        return false;
    }
    if (controller && state.controller != controller) {
        return false;
    }
    if (!inputElement || inputElement.isConnected === false) {
        return false;
    }
    if (String(inputElement.value || '') != term || term.trim().length <= 2) {
        return false;
    }
    return isSearchSurfaceOpen(surface);
}

function isCurrentRecentSearch(sequence, controller) {
    return (
        recentSearchRequestState.sequence == sequence &&
        recentSearchRequestState.controller == controller &&
        recentSearchRequestState.open &&
        isSearchSurfaceOpen('drawer')
    );
}

function createSearchAbortController() {
    var controller = {
        signal: { aborted: false },
        requests: [],
        abort: function() {
            if (controller.signal.aborted) {
                return;
            }
            controller.signal.aborted = true;
            var requests = controller.requests.slice();
            controller.requests.length = 0;
            requests.forEach(function(request) {
                abortSearchController(request);
            });
        }
    };
    return controller;
}

function removeSearchTransportRequest(controller, request) {
    if (!controller || !controller.requests) {
        return;
    }
    var requestIndex = controller.requests.indexOf(request);
    if (requestIndex > -1) {
        controller.requests.splice(requestIndex, 1);
    }
}

function createSearchAbortError() {
    var error = new Error('Search request aborted');
    error.name = 'AbortError';
    return error;
}

function requestSearchResource(controller, url) {
    return new Promise(function(resolve, reject) {
        if (!controller || !controller.signal || controller.signal.aborted) {
            reject(createSearchAbortError());
            return;
        }
        if (typeof jQuery == 'undefined' || typeof jQuery.ajax != 'function') {
            reject(new Error('Search transport unavailable'));
            return;
        }
        var request;
        var doneHandler;
        var failHandler;
        var alwaysHandler;
        try {
            request = jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'text',
                global: false,
                // Shopify varies predictive-search responses by Accept. Match
                // the former Fetch request instead of jQuery's text/plain.
                headers: { Accept: '*/*' },
                timeout: UPV_SEARCH_REQUEST_TIMEOUT
            });
            // Read the complete jqXHR shape inside the guarded boundary. Some
            // storefront wrappers expose accessors rather than plain methods.
            doneHandler = request && request.done;
            failHandler = request && request.fail;
            alwaysHandler = request && request.always;
        } catch (error) {
            abortSearchController(request);
            reject(error);
            return;
        }
        if (
            !request ||
            typeof doneHandler != 'function' ||
            typeof failHandler != 'function' ||
            typeof alwaysHandler != 'function'
        ) {
            abortSearchController(request);
            reject(new Error('Search transport unavailable'));
            return;
        }
        // A synchronous Ajax prefilter can re-enter drawer/search cleanup.
        // Never attach an already-retired transport to the closed group.
        if (controller.signal.aborted) {
            abortSearchController(request);
            reject(createSearchAbortError());
            return;
        }
        controller.requests.push(request);
        try {
            doneHandler.call(request, function(data) {
                resolve({
                    ok: true,
                    text: function() {
                        return Promise.resolve(typeof data == 'string' ? data : String(data || ''));
                    },
                    json: function() {
                        return new Promise(function(resolveJson, rejectJson) {
                            try {
                                resolveJson(typeof data == 'string' ? JSON.parse(data) : data);
                            } catch (error) {
                                rejectJson(error);
                            }
                        });
                    }
                });
            });
            failHandler.call(request, function(xhr, status, errorThrown) {
                var error = errorThrown instanceof Error
                    ? errorThrown
                    : new Error(status || 'Search request failed');
                if (status == 'abort') {
                    error.name = 'AbortError';
                }
                reject(error);
            });
            alwaysHandler.call(request, function() {
                removeSearchTransportRequest(controller, request);
            });
            // Non-standard registration methods can also re-enter cleanup. A
            // request already in the group was aborted exactly once there; the
            // final rejection only closes this Promise facade.
            if (controller.signal.aborted) {
                removeSearchTransportRequest(controller, request);
                reject(createSearchAbortError());
            }
        } catch (error) {
            removeSearchTransportRequest(controller, request);
            if (!controller.signal.aborted) {
                abortSearchController(request);
            }
            reject(error);
        }
    });
}

function isSearchAbortError(error) {
    return error && error.name == 'AbortError';
}

function getSearchStorage() {
    try {
        return window.localStorage;
    } catch (error) {
        return null;
    }
}

function safeReadRecentSearch() {
    var storage = getSearchStorage();
    if (!storage) {
        return [];
    }
    try {
        var value = JSON.parse(storage.getItem('Recent_search'));
        if (!Array.isArray(value)) {
            return [];
        }
        return value.filter(function(handle) {
            return typeof handle == 'string' && handle.length > 0;
        });
    } catch (error) {
        return [];
    }
}

function safeWriteRecentSearch(value) {
    var storage = getSearchStorage();
    if (!storage) {
        return false;
    }
    try {
        storage.setItem('Recent_search', JSON.stringify(value));
        return true;
    } catch (error) {
        return false;
    }
}

function buildPredictiveSearchUrl(sectionId, term, resultType) {
    var parameters = new URLSearchParams();
    parameters.set('section_id', sectionId);
    parameters.set('q', term);
    parameters.set('resources[type]', resultType);
    parameters.set('resources[options][fields]', 'author,tag,title,product_type,variants.title,vendor,variants.sku');
    return searchUrl + '/suggest?' + parameters.toString();
}

function getRecentProductHandle() {
    if (typeof window.recentProductHandle == 'string') {
        return window.recentProductHandle;
    }
    if (typeof recentProductHandle != 'undefined' && typeof recentProductHandle == 'string') {
        return recentProductHandle;
    }
    return '';
}

window.UpvanitySearchLifecycle = {
    predictiveStates: predictiveSearchStates,
    recentState: recentSearchRequestState,
    recentView: recentSearchViewState,
    cancel: cancelPredictiveSearch,
    cancelRecent: cancelRecentSearchRequest,
    cancelAll: cancelAllSearchRequests,
    buildUrl: buildPredictiveSearchUrl,
    readRecent: safeReadRecentSearch
};

function releaseSearchForPageHide() {
    cancelAllSearchRequests();
    clearPredictiveSearchSurface('drawer');
    clearPredictiveSearchSurface('header');
    resetRecentSearchView(false);
    $('body').removeClass(getSearchDrawerClass());
    if (typeof stopFocusElementsRotation == 'function') {
        stopFocusElementsRotation();
    }
}

window.addEventListener('pagehide', releaseSearchForPageHide);

function removeHtmlEntities(str) {
    const htmlEntities = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&apos;"
    };
    return str.replace(/([&<>\"'])/g, match => htmlEntities[match]);
}

function searchTabsInit() {
    var tabHead = document.getElementsByClassName('yv-tab-result-head');
    if (tabHead.length > 0) {
        var tabContent = document.getElementsByClassName('yv-search-result-list');
        Array.from(tabHead).forEach(function(btn) {
            if (btn.getAttribute('data-search-tab-bound') == 'true') {
                return;
            }
            btn.setAttribute('data-search-tab-bound', 'true');
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                Array.from(tabHead).forEach(function(item) {
                item.classList.remove('active');
                });
                let searchUrl = btn.getAttribute("data-resulturl");
                let searchContainer = document.querySelector('.search-bar-container');
                if (searchContainer) {
                    let allresultLink = searchContainer.querySelector('.search-result-bottom');
                    if (allresultLink && searchUrl) {
                        allresultLink.setAttribute('href', searchUrl);
                    }
                }
                Array.from(tabContent).forEach(function(item) {
                    item.classList.remove('active');
                });
                btn.classList.add("active");
                var _value = btn.getAttribute("data-results");
                var activeContent = document.getElementById(_value);
                if (activeContent) {
                    activeContent.classList.add("active");
                }
            });
        });
    }
}

$(document).ready(function() {
    $('body').on('click','.search-form',function(e) {
        e.preventDefault();
        focusElement = $(this);
        var _class = $(this).data('search-drawer');
        $('body').toggleClass(_class);
        if ($('body').hasClass(_class)) {
            predictiveSearchStates.drawer.open = true;
            $('input.search-input').trigger('focus');
            $('#recent_search_list').html('');
            recentSearch();
            focusElementsRotation($('.search-bar-container'));
        } else {
            cancelPredictiveSearch('drawer');
            cancelRecentSearchRequest();
            clearPredictiveSearchSurface('drawer');
            resetRecentSearchView(false);
            stopFocusElementsRotation();
        }
    });

    /// AjaX Product Search
    $('.AjaxSearchResponse').prepend('');
    $('.search-close').show();
    $('body').on('keydown', '.search-input', function(e) {
       if (this.value.length === 0 && e.which === 32) e.preventDefault();
    });
    $('body').on('keyup', '.search-input', function(e) {
        var _this = $(this);
        searchResults(_this)
    })


    //Search box should mimic live search string: products only, partial match
    $('.search-form, #search-form').on('submit', function(e) {
        e.preventDefault();
        var term = '*' + $(this).find('input[name="q"]').val() + '*';
        var parameters = new URLSearchParams();
        parameters.set('q', term);
        parameters.set('options[prefix]', 'last');
        var linkURL = $(this).attr('action') + '?' + parameters.toString();
        window.location = linkURL;
    });

    $('body').on('click', '.yv-search-drawer-close', function(e) {
        e.preventDefault();
        cancelPredictiveSearch('drawer');
        cancelRecentSearchRequest();
        getSearchInput('drawer').val('');
        getSearchResultBox('drawer').empty();
        resetRecentSearchView(false);
        $('body').removeClass(getSearchDrawerClass());
        stopFocusElementsRotation();
        var searchReturnTarget = focusElement;
        if (upvanityFocusSearchReturnTarget(searchReturnTarget)) {
            if (focusElement === searchReturnTarget) focusElement = '';
        } else if (focusElement && typeof focusElement.trigger == 'function') {
            focusElement.trigger('focus');
        } else if (focusElement && typeof focusElement.focus == 'function') {
            focusElement.focus();
        }
    });


  $('body').on('click', '.yv-search-bar', function(e) {
    if($(this).val().length > 2){
        $('.yv-header-searchbar-content').show();
    }
  })

   $(document).on("click","button[data-searchbar-cross]",function(e) {
     e.preventDefault();
     cancelPredictiveSearch('header');
     $(this).hide();
     $(".yv-search-bar").val("");
     getSearchResultBox('header').hide().empty();
   })
   $(document).on('click', function(e) {
     var headerState = predictiveSearchStates.header;
     if (
       (headerState.open || headerState.timer || headerState.controller) &&
       !$(e.target).closest('.yv-header-searchbar-box').length
     ) {
       cancelPredictiveSearch('header');
       clearPredictiveSearchSurface('header');
     }
   });
   $('body').on('mouseup keydown', function(e) {
     if (e.type == 'keydown' && e.key != 'Escape' && e.keyCode != 27) {
       return;
     }
     var drawerState = predictiveSearchStates.drawer;
     if (
       (drawerState.open || drawerState.timer || drawerState.controller || recentSearchRequestState.open)
     ) {
       setTimeout(function() {
         if (!isSearchSurfaceOpen('drawer')) {
           cancelPredictiveSearch('drawer');
           cancelRecentSearchRequest();
           clearPredictiveSearchSurface('drawer');
           resetRecentSearchView(false);
           stopFocusElementsRotation();
         }
       }, 0);
     }
   });
    // search ends
});


function recentSearch() {
    cancelRecentSearchRequest();
    recentSearchRequestState.open = true;
    var sequence = recentSearchRequestState.sequence;
    resetRecentSearchView(true);
    recentSearchRequestState.timer = setTimeout(function() {
        recentSearchRequestState.timer = null;
        if (
            recentSearchRequestState.sequence != sequence ||
            !recentSearchRequestState.open ||
            !isSearchSurfaceOpen('drawer')
        ) {
            return;
        }
        var recentProducts = safeReadRecentSearch().slice().reverse().slice(0, 10);
        if (recentProducts.length == 0) {
            updateRecentSearchView('', true);
            return;
        }
        var controller = createSearchAbortController();
        recentSearchRequestState.controller = controller;
        var finishRecentSearchRequest = function() {
            if (
                recentSearchRequestState.sequence == sequence &&
                recentSearchRequestState.controller == controller
            ) {
                if (recentSearchRequestState.deadlineTimer) {
                    clearTimeout(recentSearchRequestState.deadlineTimer);
                    recentSearchRequestState.deadlineTimer = null;
                }
                recentSearchRequestState.controller = null;
            }
        };
        recentSearchRequestState.deadlineTimer = setTimeout(function() {
            if (
                recentSearchRequestState.sequence != sequence ||
                recentSearchRequestState.controller != controller ||
                !recentSearchRequestState.open
            ) {
                return;
            }
            recentSearchRequestState.deadlineTimer = null;
            recentSearchRequestState.controller = null;
            abortSearchController(controller);
            updateRecentSearchView('', true);
        }, UPV_SEARCH_REQUEST_TIMEOUT);
        var productUrl = rootUrl.length > 1 ? rootUrl : '';
        var productRequests = recentProducts.map(function(handle) {
            var productRequest;
            try {
                productRequest = requestSearchResource(
                    controller,
                    productUrl + '/products/' + encodeURIComponent(handle) + '.json'
                );
            } catch (error) {
                return Promise.resolve(null);
            }
            return Promise.resolve(productRequest)
                .then(function(response) {
                    if (!response || !response.ok) {
                        throw new Error('Recent search request failed');
                    }
                    // A timed-out, closed or superseded request must not spend
                    // CPU/memory decoding a body that can no longer be shown.
                    if (!isCurrentRecentSearch(sequence, controller)) {
                        return null;
                    }
                    return response.json();
                })
                .then(function(response) {
                    if (!isCurrentRecentSearch(sequence, controller)) {
                        return null;
                    }
                    return response && response.product ? response.product : null;
                })
                .catch(function(error) {
                    if (isSearchAbortError(error) || (controller.signal && controller.signal.aborted)) {
                        throw error;
                    }
                    return null;
                });
        });
        Promise.all(productRequests)
            .then(function(products) {
                if (
                    recentSearchRequestState.sequence != sequence ||
                    recentSearchRequestState.controller != controller ||
                    !recentSearchRequestState.open ||
                    !isSearchSurfaceOpen('drawer')
                ) {
                    return;
                }
                var recentItems = products.filter(function(product) {
                    return product && product.handle && product.title;
                });
                if (recentItems.length == 0) {
                    updateRecentSearchView('', true);
                    return;
                }
                var recentHtml = '<h6 class="recent-search-title">' + searchRecentTitleText + '</h6>';
                recentHtml += '<ul class="list-unstyled recent-search-listing">';
                recentItems.forEach(function(product) {
                    var productTitle = String(product.title || '');
                    var safeProductTitle = removeHtmlEntities(productTitle);
                    var imageHtml = noProductImage;
                    if (product.image && product.image.src) {
                        var imageSource = String(product.image.src);
                        imageSource += imageSource.indexOf('?') > -1 ? '&width=100' : '?width=100';
                        imageHtml = '<img src="' + removeHtmlEntities(imageSource) + '" alt="' + safeProductTitle + '">';
                    }
                    recentHtml += '<li><a class="focus-inside" href="' + productUrl + '/products/' + encodeURIComponent(product.handle) + '">';
                    recentHtml += imageHtml + '<span>' + truncate(safeProductTitle, 2) + '</span></a></li>';
                });
                recentHtml += '</ul>';
                updateRecentSearchView(recentHtml, false);
                if (recentSearchViewState.visible && typeof focusElementsRotation == 'function') {
                    focusElementsRotation($('.search-bar-container'));
                }
            })
            .catch(function(error) {
                if (
                    !isSearchAbortError(error) &&
                    recentSearchRequestState.sequence == sequence &&
                    recentSearchRequestState.controller == controller
                ) {
                    updateRecentSearchView('', true);
                }
            })
            .then(finishRecentSearchRequest, finishRecentSearchRequest);
    }, 500);
}

function clearPredictiveSearchSurface(surface) {
    var resultBox = getSearchResultBox(surface);
    resultBox.empty();
    if (surface == 'header') {
        $('button[data-searchbar-cross]').hide();
        resultBox.css('display', 'none');
    } else {
        var searchContainer = $('body').find('.search-bar-container');
        searchContainer.find('[data-search-suggestions]').empty();
    }
}

function renderPredictiveSearchResults(surface, resultSection) {
    var resultBox = getSearchResultBox(surface);
    if (surface == 'header') {
        resultBox.html(resultSection.innerHTML);
        return;
    }
    var searchContainer = $('body').find('.search-bar-container');
    var suggestionBox = searchContainer.find('[data-search-suggestions]');
    if (suggestionBox.length > 0) {
        var suggestions = resultSection.querySelector('[data-search-suggestions]');
        if (suggestions) {
            suggestionBox.html(suggestions.innerHTML);
            suggestions.innerHTML = '';
        } else {
            suggestionBox.empty();
        }
    }
    // The predictive section may set this value while jQuery inserts its scripts.
    // Clear any previous product first so an empty response cannot reuse it.
    window.recentProductHandle = '';
    resultBox.html(resultSection.innerHTML);
    searchTabsInit();
    var recentProduct = getRecentProductHandle();
    window.recentProductHandle = '';
    if (recentProduct) {
        var recentProducts = safeReadRecentSearch();
        if (recentProducts.includes(recentProduct) === false) {
            recentProducts.push(recentProduct);
            safeWriteRecentSearch(recentProducts);
        }
    }
    if (typeof focusElementsRotation == 'function') {
        focusElementsRotation($('.search-bar-container'));
    }
}

function searchResults(inputField){
    var surface = getSearchSurface(inputField);
    var inputElement = inputField && inputField.length ? inputField[0] : null;
    var term = inputElement ? String(inputElement.value || '') : '';
    if (surface == 'drawer') {
        // Cache the once-per-opening recent HTML outside the focusable DOM while
        // predictive results own the drawer, then restore it without refetching.
        setRecentSearchViewVisible(term.trim().length <= 2);
    }
    var sequence = beginPredictiveSearchIntent(surface, inputElement);
    if (term.trim().length <= 2) {
        clearPredictiveSearchSurface(surface);
        return;
    }
    var resultType = 'product';
    if (searchPageResults) {
        resultType += ',page';
    }
    if (searchArticleResults) {
        resultType += ',article';
    }
    if (searchSuggestions) {
        resultType += ',query';
    }
    var sectionId = surface == 'header' ? 'predictive-search-lite' : 'predictive-search';
    var state = predictiveSearchStates[surface];
    state.timer = setTimeout(function() {
        state.timer = null;
        if (!isCurrentPredictiveSearch(surface, sequence, inputElement, term)) {
            setSearchBusy(surface, false, inputElement);
            return;
        }
        var resultBox = getSearchResultBox(surface);
        if (!resultBox.length) {
            cancelPredictiveSearch(surface);
            return;
        }
        var controller = createSearchAbortController();
        state.controller = controller;
        var finishPredictiveSearchRequest = function() {
            if (state.sequence == sequence && state.controller == controller) {
                if (state.deadlineTimer) {
                    clearTimeout(state.deadlineTimer);
                    state.deadlineTimer = null;
                }
                state.controller = null;
                setSearchBusy(surface, false, inputElement);
            }
        };
        setSearchBusy(surface, true, inputElement);
        resultBox.html(preLoadLoadGif);
        if (surface == 'header') {
            resultBox.show();
            $('button[data-searchbar-cross]').show();
        } else if (typeof focusElementsRotation == 'function') {
            // Dynamic links from an earlier result may have just been detached.
            // Refresh the trap now so a slow or failed request cannot leak focus.
            focusElementsRotation($('.search-bar-container'));
        }
        state.deadlineTimer = setTimeout(function() {
            if (!isCurrentPredictiveSearch(
                surface,
                sequence,
                inputElement,
                term,
                controller
            )) {
                return;
            }
            state.deadlineTimer = null;
            state.controller = null;
            abortSearchController(controller);
            clearPredictiveSearchSurface(surface);
            setSearchBusy(surface, false, inputElement);
            if (surface == 'drawer' && typeof focusElementsRotation == 'function') {
                focusElementsRotation($('.search-bar-container'));
            }
        }, UPV_SEARCH_REQUEST_TIMEOUT);
        var predictiveRequest;
        try {
            predictiveRequest = requestSearchResource(
                controller,
                buildPredictiveSearchUrl(sectionId, term, resultType)
            );
        } catch (error) {
            if (isCurrentPredictiveSearch(
                surface,
                sequence,
                inputElement,
                term,
                controller
            )) {
                if (state.deadlineTimer) clearTimeout(state.deadlineTimer);
                state.deadlineTimer = null;
                state.controller = null;
                clearPredictiveSearchSurface(surface);
                setSearchBusy(surface, false, inputElement);
            }
            return;
        }
        Promise.resolve(predictiveRequest)
            .then(function(response) {
                if (!response || !response.ok) {
                    throw new Error('Predictive search request failed');
                }
                // Do not read a response body after this request has lost
                // ownership (timeout, close, navigation or a newer query).
                if (!isCurrentPredictiveSearch(surface, sequence, inputElement, term, controller)) {
                    return null;
                }
                return response.text();
            })
            .then(function(resultHtml) {
                if (!isCurrentPredictiveSearch(surface, sequence, inputElement, term, controller)) {
                    return;
                }
                var resultDocument = new DOMParser().parseFromString(resultHtml, 'text/html');
                if (!isCurrentPredictiveSearch(surface, sequence, inputElement, term, controller)) {
                    return;
                }
                var resultSection = resultDocument.querySelector('#shopify-section-' + sectionId);
                if (!resultSection) {
                    throw new Error('Predictive search section missing');
                }
                if (!isCurrentPredictiveSearch(surface, sequence, inputElement, term, controller)) {
                    return;
                }
                renderPredictiveSearchResults(surface, resultSection);
            })
            .catch(function(error) {
                if (
                    !isSearchAbortError(error) &&
                    isCurrentPredictiveSearch(surface, sequence, inputElement, term, controller)
                ) {
                    clearPredictiveSearchSurface(surface);
                }
            })
            .then(finishPredictiveSearchRequest, finishPredictiveSearchRequest);
    }, 1000);
}

function speechInit() {
    let searchBySpeechs = document.querySelectorAll("[data-speech-search]");
    Array.from(searchBySpeechs).forEach(function (searchBySpeech) {
        initSpeectRecognition(searchBySpeech);
    });
}
function initSpeectRecognition(searchSpeech) {
    if (searchSpeech.getAttribute('data-speech-search-bound') == 'true') {
        return;
    }
    searchSpeech.setAttribute('data-speech-search-bound', 'true');
    let speechRecognition = null;
    let listening = false;
    let searchInput = null;
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (
        "webkitSpeechRecognition" in window &&
        userAgent.indexOf("chrome") > -1 &&
        !!window.chrome &&
        userAgent.indexOf("edg/") === -1
    ) {
        searchSpeech.classList.remove("hidden");
        speechRecognition = new window.webkitSpeechRecognition();
        speechRecognition.continuous = false;
        speechRecognition.interimResults = false;
        searchInput = searchSpeech
            .closest("form")
            .querySelector("[data-search-input]");
        speechRecognition.addEventListener(
            "result",
            debounce((evt) => {
                if (evt.results) {
                    const term = evt.results[0][0].transcript;
                    searchInput.value = term;
                    searchInput.focus();
                    searchInput.dispatchEvent(new Event("input"));
                    searchResults($(searchInput))
                }
            }, 300)
        );

        speechRecognition.addEventListener("audiostart", () => {
            listening = true;
            searchSpeech.classList.add("active");
        });

        speechRecognition.addEventListener("audioend", () => {
            listening = false;
            searchSpeech.classList.remove("active");
        });

        searchSpeech.addEventListener("click", function (evt) {
            evt.preventDefault();
            if (listening) {
                speechRecognition.stop();
                listening = false;
            } else {
                speechRecognition.start();
                listening = true;
            }
        });

        searchSpeech.addEventListener("keydown", (evt) => {
            if (evt.code === "Space" || evt.code === "Enter") {
                evt.preventDefault();
                if (listening) {
                    speechRecognition.stop();
                } else {
                    speechRecognition.start();
                }
            }
        });
    }
}
